@if (chatSuggestion && chatSuggestion.status === 'waiting' && isSupportedType) {
  <tidy-card class="chat-suggestion-card suggested">
    <tidy-row>
      <tidy-text [body]="suggestionTitle" />
    </tidy-row>

    @if (chatSuggestion?.name === 'reschedule_booking') {
      <div class="reschedule-details">
        <tidy-row>
          <tidy-text [body]="serviceTypeName || 'Job' + ' ' + formattedCurrentJobDate + (' at ' | translate) + formattedCurrentJobTime" />
        </tidy-row>
        @if (homekeeperName) {
          <tidy-row>
            <tidy-text [body]="('with ' | translate) + homekeeperName + (' to:' | translate)" />
          </tidy-row>
        }
        @if (hasRescheduleDateTime) {
          <tidy-row class="new-datetime first">
            <tidy-text [body]="('New Date: ' | translate) + formattedRescheduleDate" />
          </tidy-row>
          <tidy-row class="new-datetime">
            <tidy-text [body]="('New Time: ' | translate) + formattedRescheduleTime" />
          </tidy-row>
        }
      </div>
    }

    @if (suggestedMessage) {
      <tidy-row class="message-preview">
        <tidy-text [body]="suggestedMessage" />
      </tidy-row>
    }

    <tidy-row [alignLastItemRight]="true" class="no-padding">
      <div class="card-actions">
        <button
          class="no-btn"
          [disabled]="isDismissing || isPerforming"
          (click)="onDismiss()">
          @if (isDismissing) {
            <ion-spinner name="crescent" class="btn-spinner" />
          } @else {
            <span>No</span>
          }
        </button>
        <button
          class="yes-btn"
          [disabled]="isPerforming || isDismissing"
          (click)="onSend()">
          @if (isPerforming) {
            <ion-spinner name="crescent" class="btn-spinner" />
          } @else {
            <span>Yes</span>
          }
        </button>
      </div>
    </tidy-row>
  </tidy-card>
}
